<template>
  <BtnToggle 
    :title="'Unlink'"
    @click="onClick"
  >
    <i class="far fa-unlink fs-16"></i>
  </BtnToggle>
</template>

<script>
import { mapGetters } from "vuex";
import BtnToggle from "./_BtnToggle";

export default {
  components: {
    BtnToggle,
  },
  data() {
    return {
      formatLinkClear: {
        linkType: false,
        linkTarget: false,
        link: false,
        linkPageID: false,
        linkSectionID: false,
        linkFileID: false,
        linkFileName: false,
        linkPhoneCode: false,

        linkTypeOld: false,
        linkPageIdOld: false,
        linkSectionIdOld: false,
        linkDocNameOld: false,
        phoneCodeOld: false,

        underline: false,
        decoration: false,
      }
    }
  },
  computed: {
    ...mapGetters({
      languageEngine: "designIframe/userPreference/languageEngine",
      texteditor: "designIframe/texteditor/texteditor",
    }),
  },
  methods: {
    onClick() {
      const selection = this.texteditor.editor.getSelection();
      this.texteditor.editor.formatText(selection, this.formatLinkClear);
    }
  },
}
</script>
